import * as React from 'react';
import { QuestionDto, QuestionType } from '../../../pages/questionTypes';
import { Grid, StyleRulesCallback, WithStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { AnswerDto, getEmptyAnswerDto } from '../../../pages/answerTypes';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { addOrUpdateAnswer } from '../../../pages/assessment/answeredCatalogueApi';
import TextQuestion from './questionTypes/TextQuestion';
import MultipleChoiceQuestion from './questionTypes/MultipleChoiceQuestion';
import MultipleColumnQuestion from './questionTypes/MultipleColumnQuestion';
import QuestionHeader from '../common/QuestionHeader';
import { AnsweredCatalogueDto } from '../../../pages/answeredCatalogueTypes';

interface Props {
  question: QuestionDto,
  existingAnswer?: AnswerDto,
  catalogueId: number,
  updateAnsweredCatalogue: (updatedCatalogue: AnsweredCatalogueDto) => void
}

type LocalStyles = 'root';

const localStyles: StyleRulesCallback<LocalStyles> = () => ({
  root: {
    flexGrow: 1,
  },
});

type PropsWithStyle = WithStyles<LocalStyles> & Props;

@observer
class Question extends React.Component<PropsWithStyle> {

  @observable private answer: AnswerDto = getEmptyAnswerDto();

  constructor(props: PropsWithStyle) {
    super(props);

    this.answer.question = this.props.question;
    if (this.props.existingAnswer !== undefined) {
      this.answer.answer = this.props.existingAnswer.answer
    }

  }

  public render() {
    return (
      <div className={this.props.classes.root}>
        <Grid container={true}>
          <Grid item={true} sm={12} md={4}>
            <QuestionHeader question={this.props.question.question} description={this.props.question.description}/>
          </Grid>
          {this.renderQuestionSection()}
        </Grid>
      </div>
    )
  }

  private renderQuestionSection() {
    switch (this.props.question.questionType) {
      case QuestionType.TEXT: {
        return (
          <TextQuestion question={this.props.question} existingAnswer={this.props.existingAnswer}
                        saveAnswer={this.saveAnswer}/>
        )
      }
      case QuestionType.MULTIPLE_COLUMNS: {
        return (
          <MultipleColumnQuestion question={this.props.question}
                                  existingAnswer={this.props.existingAnswer} saveAnswer={this.saveAnswer}/>
        )
      }
      case QuestionType.MULTIPLE_CHOICE: {
        return (
          <MultipleChoiceQuestion question={this.props.question} existingAnswer={this.props.existingAnswer}
                                  saveAnswer={this.saveAnswer}/>
        )
      }
    }
  }

  private saveAnswer = (answer: AnswerDto) => {
    addOrUpdateAnswer(answer, this.props.catalogueId).then( data =>
      this.props.updateAnsweredCatalogue(data)
    )
  }

}

export default withStyles(localStyles)(Question);
